"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePassword = exports.ALLOWED_CHARACTERS = exports.PASSWORD_LENGTH = void 0;
exports.PASSWORD_LENGTH = 18;
exports.ALLOWED_CHARACTERS = {
    lowerCase: 'abcdefghijklmnopqrstuvwxyz',
    upperCase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    numbers: '0123456789',
    symbols: '^$*.[]{}()?-"!@#%&/,><\':;|_~`+='
};
var _getRandomCharacter = function (str) { return str.charAt(Math.floor(Math.random() * str.length)); };
var _shuffleCharacters = function (str) {
    return str
        .split('')
        .sort(function () { return 0.5 - Math.random(); })
        .join('');
};
/**
 * @returns {string} return randomly-generated password
 */
var generatePassword = function () {
    var password = '';
    var allCharacters = Object.values(exports.ALLOWED_CHARACTERS).join('');
    // ensure password contains at least one of each required character group
    password += _getRandomCharacter(exports.ALLOWED_CHARACTERS.lowerCase);
    password += _getRandomCharacter(exports.ALLOWED_CHARACTERS.upperCase);
    password += _getRandomCharacter(exports.ALLOWED_CHARACTERS.numbers);
    password += _getRandomCharacter(exports.ALLOWED_CHARACTERS.symbols);
    // populate rest of password with random characters from any group
    while (password.length < exports.PASSWORD_LENGTH) {
        password += _getRandomCharacter(allCharacters);
    }
    // return shuffled password to avoid predictable group patterns
    return _shuffleCharacters(password);
};
exports.generatePassword = generatePassword;
//# sourceMappingURL=index.js.map